import { render, staticRenderFns } from "./ReceiptDetails.vue?vue&type=template&id=356947d2&scoped=true"
import script from "./ReceiptDetails.vue?vue&type=script&lang=js"
export * from "./ReceiptDetails.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDetails.vue?vue&type=style&index=0&id=356947d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356947d2",
  null
  
)

export default component.exports